import { render } from "./SemesterTestCalendar.vue?vue&type=template&id=2146d72e&scoped=true"
import script from "./SemesterTestCalendar.vue?vue&type=script&lang=js"
export * from "./SemesterTestCalendar.vue?vue&type=script&lang=js"

import "./SemesterTestCalendar.vue?vue&type=style&index=0&id=2146d72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2146d72e"]])

export default __exports__